import { useEffect, useState } from "react";

import { FooterModal } from "components/common/modal/Footer";
import RadioButton from "components/common/RadioButton";
import { Body } from "components/common/modal/Body";
import { HeaderModal } from "components/common/modal/Header";
import { Modal } from "components/common/modal/Modal";

import allImgPaths from "assets/images";
import objectiveIcon from "../../assets/images/objective-icon.svg";
import { InputTextField } from "components/InputField";
import CustomCheckBox from "components/CustomCheckBox";

const AddCustomBoxModal = ({ isShowModal, setIsShowModal, addCustomBox }: any) => {
    const [boxSelected, setBoxSelected] = useState(true);
    const [boxType, setBoxType] = useState('common_input');
    const [boxTitle, setBoxTitle] = useState('');
    const [boxDescription, setBoxDescription] = useState('');
    const [asAttachment, setAsAttachment] = useState(false);
    const [asPreview, setAsPreview] = useState(false);

    let radioOptionsInput = [
        {
            label: "Common Input",
            value: "common_input",
            extraText: "For a combination of simple formatted text, images, links drafted by AI of pasted by you.",
        }
    ]

    let radioOptionsFile = [
        {
            label: "File Upload",
            value: "file_upload",
            extraText: "For files that need to be on screen like your signature or to attached along with the draft.",
        }
    ]

    const handleObjectiveChange = (event: any) => {
        if (event.target.name === "objective") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }

            setBoxDescription(event.target.value)
        }
    };

    // const [isShow, setisShow] = useState(false);
    const onCloseModal = () => {
        setIsShowModal(!isShowModal);
    }
    const [selectedOption, setSelectedOption] = useState('common_input');

    const handleOptionChange = (value: string) => {
        setSelectedOption(value);
        setBoxSelected(value === 'common_input');
        setBoxType(value)

        if (value != 'common_input') {
            setBoxDescription('')
        }
    };

    const handleChange = (name: any, isChecked: boolean) => {
        if (name == 'attachment') setAsAttachment(isChecked)
        if (name == 'preview') setAsPreview(isChecked)
    }

    const add = () => {
        let addObject: any = {
            boxType, boxTitle, boxDescription
        }

        if (boxType == 'common_input') {
            addObject = { ...addObject, type: 'text', componentName: 'RfpInnerText' }
        } else {
            addObject = { ...addObject, asAttachment, asPreview, type: 'image', componentName: 'RfpInnerLogo' }
        }
        addCustomBox(addObject)
        setIsShowModal(false)
    }

    return (
        <>
            {/* Modal */}
            <Modal
                className='modal-wrapper max-w-[480px]'
                isShow={isShowModal}
            >
                <div>
                    <HeaderModal
                        title="Fete Settings"
                        isShowHeader={true}
                        className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
                    >
                        <div className="flex items-center justify-between">
                            <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                                Add Custom box
                            </h2>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>

                        <p className="text-sm text-[#475467]">
                            Tell us what you would like to be added to this draft
                        </p>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body pl-6 pr-5 pt-5 max-h-[calc(100vh_-_448px)] overflow-y-scroll scrollbar-adjust">
                        <div className="mb-6">
                            <p className="text-sm font-interMedium text-[#344054] pb-2">Box Type</p>

                            <div className="flex gap-x-5 mb-6">
                                <div className="w-1/2">
                                    <RadioButton
                                        options={radioOptionsInput}
                                        selectedOption={selectedOption}
                                        onOptionChange={handleOptionChange}
                                    />
                                </div>
                                <div className="w-1/2">
                                    <RadioButton
                                        options={radioOptionsFile}
                                        selectedOption={selectedOption}
                                        onOptionChange={handleOptionChange}
                                    />
                                </div>
                            </div>

                            <div className="">

                                {/* Title */}
                                <div className="mb-6">
                                    <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                        Box Title
                                    </p>
                                    <div className="relative ">
                                        <div className="">
                                            <InputTextField
                                                className="placeholder:text-[#D0D5DD] placeholder:text-base text-base text-[#344054] w-full box-title-icon !pl-10"
                                                name={"name"}
                                                placeholder={"Enter here"}
                                                onChange={(e) => setBoxTitle(e.target.value)}
                                                value={boxTitle}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Description | Common Input */}
                                {
                                    boxSelected &&
                                    <div className="">
                                        <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                            Box Description
                                        </p>
                                        <div className="relative">
                                            <div className="border border-[#D0D5DD] rounded-lg flex items-start gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                                                <img
                                                    className="w-[22px] h-[22px] flex-shrink-0 mt-0.5"
                                                    src={objectiveIcon}
                                                    alt="star icon"
                                                />
                                                <textarea
                                                    id="textAreaRef"
                                                    name="objective"
                                                    value={boxDescription}
                                                    onChange={handleObjectiveChange}
                                                    className="placeholder:text-[#D0D5DD] placeholder:text-base text-base text-[#344054] w-full h-[24px]"
                                                    placeholder="Tell us about this box, what it should contain."
                                                    style={{
                                                        width: "100%",
                                                        boxSizing: "border-box",
                                                        overflow: "hidden",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }

                                {/* Description | File Upload */}
                                {
                                    !boxSelected &&

                                    < div className="">
                                        <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                            Upload as
                                        </p>

                                        <div className="flex items-center mb-4">
                                            <span className="checkbox-alignment">
                                                <CustomCheckBox
                                                    name={'attachment'}
                                                    label={'Attachment'}
                                                    checked={asAttachment}
                                                    customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5"
                                                    onChange={handleChange}
                                                />
                                                {/* <span className="text-sm text-[#475467] font-interRegular pl-6">The file goes as a link in the draft.</span> */}
                                                <span className="text-sm text-[#475467] font-interRegular pl-6">
                                                    Maximum upload file size is 5 MB
                                                </span>
                                            </span>
                                        </div>

                                        {/* <div className="flex items-center">
                                            <span className="checkbox-alignment">
                                                <CustomCheckBox
                                                    name={'preview'}
                                                    label={'Paste preview in file'}
                                                    checked={asPreview}
                                                    customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5"
                                                    onChange={handleChange}
                                                />
                                                <span className="text-sm text-[#475467] font-interRegular pl-6">You can see a preview of the file in the draft.</span>
                                            </span>
                                        </div> */}

                                    </div>
                                }
                            </div>
                        </div>
                    </Body>

                    <FooterModal
                        title=""
                        isShowFooter={true}
                        className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]"
                    >
                        <div className="flex items-center gap-x-3 justify-center">
                            <button
                                type="button"
                                onClick={onCloseModal}
                                className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 hover:bg-[#f2f4f7]"
                            >
                                Cancel
                            </button>
                            <button
                                className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1"
                                onClick={add}
                            >
                                Add Box
                            </button>
                        </div>
                    </FooterModal>
                </div>
            </Modal >
        </>
    );
};

export default AddCustomBoxModal;
